import { PivotStore } from 'sites/enroll.pivothealth.com/thank-you/types'

// TODO: Complete the details of the function getMulticarrierCoverageDetails depending on more scenarios
export default function getMultiCarrierCoverageDetails(state: PivotStore) {
  if (!state.multiCarrierOrder || !state.multiCarrierOrder['1']) {
    return {
      policyNumber: 0,
      maxMonths: 0,
      completeLabel: '',
      available: false
    }
  }

  const policyNumber = state.multiCarrierOrder[1].length
  const maxMonths = policyNumber * 4
  const completeLabel = `1-${policyNumber}-${maxMonths}`
  const available = true

  return {
    available,
    policyNumber,
    maxMonths,
    completeLabel
  }
}
